import { Icon, Text, ToggleComponent, Tooltip } from '@bitrise/bitkit';
import useWatchApp from './hooks/useWatchApp';

const WatchAppToggle = ({ appSlug, isInitialWatching }: { appSlug: string; isInitialWatching: boolean }) => {
  const { isLoading, isWatching, toggleWatching } = useWatchApp(appSlug, isInitialWatching);

  return (
    <Tooltip label="Receive email notifications related to this project." placement="bottom">
      <Text
        alignItems="center"
        as="label"
        cursor="pointer"
        display="flex"
        gap="16"
        paddingInlineStart="32"
        paddingInlineEnd={['16', '32']}
        paddingY="12"
        htmlFor="watching-toggle"
      >
        <Icon name="ShowPassword" />
        <Text as="span" flex="1">
          Watching
        </Text>
        <ToggleComponent
          id="watching-toggle"
          isChecked={isWatching}
          isDisabled={isLoading}
          onChange={toggleWatching}
          size="sm"
        />
      </Text>
    </Tooltip>
  );
};

export default WatchAppToggle;
